// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Uuid from "uuid";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlTag from "graphql-tag";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as MutationHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/MutationHook2.res.mjs";

var Raw = {};

var query = GraphqlTag.gql(["mutation AcademyInitialiseActivity($academyActivityId: String!, $academyAttemptId: String!, $studentAttemptId: String!)  {\nacademy_initialise_activity(args: {activity_id: $academyActivityId, academy_attempt_id: $academyAttemptId, student_attempt_id: $studentAttemptId})  {\n__typename  \nstudentAttemptId  \n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.academy_initialise_activity;
  return {
          academy_initialise_activity: value$1.map(function (value) {
                var value$1 = value.studentAttemptId;
                return {
                        __typename: value.__typename,
                        studentAttemptId: !(value$1 == null) ? value$1 : undefined
                      };
              })
        };
}

function serialize(value) {
  var value$1 = value.academy_initialise_activity;
  var academy_initialise_activity = value$1.map(function (value) {
        var value$1 = value.studentAttemptId;
        var studentAttemptId = value$1 !== undefined ? value$1 : null;
        var value$2 = value.__typename;
        return {
                __typename: value$2,
                studentAttemptId: studentAttemptId
              };
      });
  return {
          academy_initialise_activity: academy_initialise_activity
        };
}

function serializeVariables(inp) {
  return {
          academyActivityId: inp.academyActivityId,
          academyAttemptId: inp.academyAttemptId,
          studentAttemptId: inp.studentAttemptId
        };
}

function makeVariables(academyActivityId, academyAttemptId, studentAttemptId, param) {
  return {
          academyActivityId: academyActivityId,
          academyAttemptId: academyAttemptId,
          studentAttemptId: studentAttemptId
        };
}

var AcademyInitialiseActivity_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Mutation.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useWithState = include.useWithState;

var AcademyInitialiseActivity = {
  AcademyInitialiseActivity_inner: AcademyInitialiseActivity_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useWithState: useWithState
};

var Init = MutationHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useWithState: useWithState
    });

var AcademyInitialiseActivityFailed = /* @__PURE__ */Caml_exceptions.create("AcademyActivityMutations-LiteracyplanetClientLibsActivity.AcademyInitialiseActivityFailed");

function useInsertAttempt(academyActivityId) {
  var mutate = Curry._1(Init.useAsync, "AcademyInitialiseActivity");
  var academyAttemptId = React.useMemo((function (param) {
          return Uuid.v4();
        }), []);
  var studentAttemptId = React.useMemo((function (param) {
          return Uuid.v4();
        }), []);
  return async function () {
    var match = await Curry._1(mutate, {
          academyActivityId: academyActivityId,
          academyAttemptId: academyAttemptId,
          studentAttemptId: studentAttemptId
        });
    var data = match.data;
    if (data !== undefined) {
      var match$1 = data.academy_initialise_activity;
      if (match$1.length !== 1) {
        throw {
              RE_EXN_ID: AcademyInitialiseActivityFailed,
              Error: new Error()
            };
      }
      var match$2 = match$1[0];
      var id = match$2.studentAttemptId;
      if (id !== undefined) {
        return id;
      }
      throw {
            RE_EXN_ID: AcademyInitialiseActivityFailed,
            Error: new Error()
          };
    }
    throw {
          RE_EXN_ID: AcademyInitialiseActivityFailed,
          Error: new Error()
        };
  };
}

var Raw$1 = {};

var query$1 = GraphqlTag.gql(["mutation MarkComplete($activityId: String!, $source: String!)  {\nacademy_mark_attempt_complete(args: {activity_id: $activityId, source_p: $source})  {\n__typename  \nkey  \nvalue  \n}\n\n}\n"]);

function parse$1(value) {
  var value$1 = value.academy_mark_attempt_complete;
  return {
          academy_mark_attempt_complete: value$1.map(function (value) {
                var value$1 = value.value;
                return {
                        __typename: value.__typename,
                        key: value.key,
                        value: !(value$1 == null) ? value$1 : undefined
                      };
              })
        };
}

function serialize$1(value) {
  var value$1 = value.academy_mark_attempt_complete;
  var academy_mark_attempt_complete = value$1.map(function (value) {
        var value$1 = value.value;
        var value$2 = value$1 !== undefined ? value$1 : null;
        var value$3 = value.key;
        var value$4 = value.__typename;
        return {
                __typename: value$4,
                key: value$3,
                value: value$2
              };
      });
  return {
          academy_mark_attempt_complete: academy_mark_attempt_complete
        };
}

function serializeVariables$1(inp) {
  return {
          activityId: inp.activityId,
          source: inp.source
        };
}

function makeVariables$1(activityId, source, param) {
  return {
          activityId: activityId,
          source: source
        };
}

var MarkCompleteMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

var include$1 = SpaceX$LiteracyplanetClientFlags.Mutation.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    });

var use$1 = include$1.use;

var useWithState$1 = include$1.useWithState;

var MarkCompleteMutation = {
  MarkCompleteMutation_inner: MarkCompleteMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: use$1,
  useWithState: useWithState$1
};

var MarkComplete = MutationHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$1,
      use: use$1,
      useWithState: useWithState$1
    });

var AcademyMarkCompleteMutationFailed = /* @__PURE__ */Caml_exceptions.create("AcademyActivityMutations-LiteracyplanetClientLibsActivity.AcademyMarkCompleteMutationFailed");

function useMarkComplete(source) {
  var mutate = Curry._1(MarkComplete.useAsync, "MarkCompleteMutation");
  return async function (activityId) {
    var match = await Curry._1(mutate, {
          activityId: activityId,
          source: source
        });
    var data = match.data;
    if (data !== undefined) {
      return Belt_Array.reduce(data.academy_mark_attempt_complete, {
                  gems: 0,
                  currentAccuracy: 0,
                  bestAccuracy: undefined,
                  bestResponsesAccuracy: undefined,
                  hasResponsesScore: undefined
                }, (function (r, row) {
                    var match = row.key;
                    switch (match) {
                      case "best_accuracy" :
                          return {
                                  gems: r.gems,
                                  currentAccuracy: r.currentAccuracy,
                                  bestAccuracy: Belt_Option.flatMap(row.value, Belt_Int.fromString),
                                  bestResponsesAccuracy: r.bestResponsesAccuracy,
                                  hasResponsesScore: r.hasResponsesScore
                                };
                      case "best_responses_accuracy" :
                          return {
                                  gems: r.gems,
                                  currentAccuracy: r.currentAccuracy,
                                  bestAccuracy: r.bestAccuracy,
                                  bestResponsesAccuracy: Belt_Option.flatMap(row.value, Belt_Int.fromString),
                                  hasResponsesScore: r.hasResponsesScore
                                };
                      case "current_accuracy" :
                          return {
                                  gems: r.gems,
                                  currentAccuracy: Belt_Option.getWithDefault(Belt_Option.flatMap(row.value, Belt_Int.fromString), 0),
                                  bestAccuracy: r.bestAccuracy,
                                  bestResponsesAccuracy: r.bestResponsesAccuracy,
                                  hasResponsesScore: r.hasResponsesScore
                                };
                      case "gems" :
                          return {
                                  gems: Belt_Option.getWithDefault(Belt_Option.flatMap(row.value, Belt_Int.fromString), 0),
                                  currentAccuracy: r.currentAccuracy,
                                  bestAccuracy: r.bestAccuracy,
                                  bestResponsesAccuracy: r.bestResponsesAccuracy,
                                  hasResponsesScore: r.hasResponsesScore
                                };
                      case "has_responses_score" :
                          return {
                                  gems: r.gems,
                                  currentAccuracy: r.currentAccuracy,
                                  bestAccuracy: r.bestAccuracy,
                                  bestResponsesAccuracy: r.bestResponsesAccuracy,
                                  hasResponsesScore: Belt_Option.map(row.value, (function (r) {
                                          return r === "true";
                                        }))
                                };
                      default:
                        return r;
                    }
                  }));
    }
    throw {
          RE_EXN_ID: AcademyMarkCompleteMutationFailed,
          Error: new Error()
        };
  };
}

var Raw$2 = {};

var query$2 = GraphqlTag.gql(["mutation AcademyUpdateState($state: String!, $studentActivityAttemptId: uuid!, $contentMd5: String!)  {\ninsert_student_activity_states_one(object: {studentAttemptId: $studentActivityAttemptId, state: $state, contentMd5: $contentMd5}, on_conflict: {constraint: student_activity_states_pkey, update_columns: [contentMd5, state]})  {\n__typename  \ncontentMd5  \n}\n\n}\n"]);

function parse$2(value) {
  var value$1 = value.insert_student_activity_states_one;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.contentMd5;
    tmp = {
      __typename: value$1.__typename,
      contentMd5: !(value$2 == null) ? value$2 : undefined
    };
  }
  return {
          insert_student_activity_states_one: tmp
        };
}

function serialize$2(value) {
  var value$1 = value.insert_student_activity_states_one;
  var insert_student_activity_states_one;
  if (value$1 !== undefined) {
    var value$2 = value$1.contentMd5;
    var contentMd5 = value$2 !== undefined ? value$2 : null;
    var value$3 = value$1.__typename;
    insert_student_activity_states_one = {
      __typename: value$3,
      contentMd5: contentMd5
    };
  } else {
    insert_student_activity_states_one = null;
  }
  return {
          insert_student_activity_states_one: insert_student_activity_states_one
        };
}

function serializeVariables$2(inp) {
  return {
          state: inp.state,
          studentActivityAttemptId: inp.studentActivityAttemptId,
          contentMd5: inp.contentMd5
        };
}

function makeVariables$2(state, studentActivityAttemptId, contentMd5, param) {
  return {
          state: state,
          studentActivityAttemptId: studentActivityAttemptId,
          contentMd5: contentMd5
        };
}

var AcademyUpdateState_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

var include$2 = SpaceX$LiteracyplanetClientFlags.Mutation.Extend({
      query: query$2,
      Raw: Raw$2,
      parse: parse$2,
      serialize: serialize$2,
      serializeVariables: serializeVariables$2
    });

var use$2 = include$2.use;

var useWithState$2 = include$2.useWithState;

var AcademyUpdateState = {
  AcademyUpdateState_inner: AcademyUpdateState_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useWithState: useWithState$2
};

var State = MutationHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$2,
      use: use$2,
      useWithState: useWithState$2
    });

var AcademyUpdateStateFailed = /* @__PURE__ */Caml_exceptions.create("AcademyActivityMutations-LiteracyplanetClientLibsActivity.AcademyUpdateStateFailed");

function useUpdateState(param) {
  var mutate = Curry._1(State.useAsync, "AcademyUpdateState");
  return async function (studentActivityAttemptId, state, contentMd5) {
    return await Curry._1(mutate, {
                state: state,
                studentActivityAttemptId: studentActivityAttemptId,
                contentMd5: contentMd5
              });
  };
}

export {
  AcademyInitialiseActivity ,
  Init ,
  AcademyInitialiseActivityFailed ,
  useInsertAttempt ,
  MarkCompleteMutation ,
  MarkComplete ,
  AcademyMarkCompleteMutationFailed ,
  useMarkComplete ,
  AcademyUpdateState ,
  State ,
  AcademyUpdateStateFailed ,
  useUpdateState ,
}
/* query Not a pure module */
